// Partenaires affichés sans consentement confirmé : retirés du badge
// « PARTENAIRE » (cartes) et de la section « Ils nous font déjà confiance ».
// NE RÉAFFICHER que sur confirmation explicite du propriétaire de Vytali.
export const UNVERIFIED_PARTNER_IDS = new Set([
  "rest_d3675f8c97af", // Au Pied de Cochon
  "rest_634f7f1d7d29", // La Banquise
  "rest_0ac551079a1e", // Le Cochon Dingue
  "rest_004c4160b8e4", // La Binerie Mont-Royal
]);

export const isUnverifiedPartner = (id) => UNVERIFIED_PARTNER_IDS.has(id);
